import { render } from "./ProjectBusiness.vue?vue&type=template&id=a93e8384"
import script from "./ProjectBusiness.vue?vue&type=script&lang=js"
export * from "./ProjectBusiness.vue?vue&type=script&lang=js"

import "./ProjectBusiness.vue?vue&type=style&index=0&id=a93e8384&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__